import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import admin from './admin'
import coinRates from './coinRates'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth, admin, coinRates
  }
})
